import POPUP from '../popup';
import './style.css';

function CONFIRMACAO(props) {

  const isLogout = props.title?.toLowerCase().includes('sair') || props.message?.toLowerCase().includes('sair');
  const iconClass = isLogout ? 'fas fa-sign-out-alt' : 'fas fa-exclamation-triangle';
  const containerClass = `confirmacao-container ${isLogout ? 'danger' : 'primary'}`;

  function CloseConfirmacao() {
    props.setTrigger(false);
  }

  function Confirmacao() {
    props.onConfirma();
    CloseConfirmacao();
  }

  return <POPUP
    trigger={props.trigger}
    setTrigger={CloseConfirmacao}>
    <div className={containerClass}>
      <div className="confirmacao-header">
        <div className="confirmacao-icon-badge">
          <i className={iconClass}></i>
        </div>
        <h3 className="confirmacao-title">{props.title}</h3>
      </div>
      
      <p className="confirmacao-message">{props.message}</p>
      
      <div className="confirmacao-footer">
        <button 
          type="button" 
          className="btn-confirmacao btn-confirmacao-cancelar" 
          onClick={() => props.setTrigger(false)}
        >
          Cancelar
        </button>
        <button 
          type="button" 
          className="btn-confirmacao btn-confirmacao-confirmar" 
          onClick={() => Confirmacao()}
        >
          Confirmar
        </button>
      </div>
    </div>
  </POPUP>
}

export default CONFIRMACAO;